export { firebaseApp, firebaseAuth, firebaseDb } from './firebase';
//export { FirebaseList } from './firebase-list';



// WEBPACK FOOTER //
// ./src/core/firebase/index.js